import React from 'react';
import { Link } from 'react-router-dom';
import "./menu";
import "./menu.css";

function Navbar () {
        // eslint-disable-next-line 
        const cargar = ()=>{
            window.location.reload()
        }


    return (
        // 

        <nav class="navbar navbar-expand-lg navbar-light fs-4">
            <div class="container-fluid">
            <a class="navbar-brand margin" href='/'>
                <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_350/v1600544930/ARBAL/SIAR/Logo_ARBAL_sin_fondo.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse navitems" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                <a class="nav-link" aria-current="page" href="/">
                Inicio
                </a>
                </li>
                <li>
                {/* <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1619739657/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-02.png" class="rounded" alt="..."></img> */}
                </li>
                <li class="menu__item container-submenu">
                    <Link to="/siar" class="nav-link" >
                        Servicios
                    </Link>
                    <ul class="submenu">
                        <li class="submenu_item mt-2">
                            <Link to="/automatizacion" class="menu__link submenu_btn" >
                                Serv. Automatizados
                            </Link>
                        </li>
                        <li class="submenu_item">
                            <Link to="/Reportes" class="menu__link submenu_btn">
                                Cultura de datos
                            </Link>
                        </li>

                        <li class="submenu_item">
                            <a href="https://arbal.wilsoftapp.com/qtraining/Users/Login?ReturnUrl=%2fqtraining%2f" target='_blank' rel='noreferrer' class="menu__link submenu_btn">
                                Capacitación
                            </a>
                        </li>
                        <li class="submenu_item">
                            <a href="http://siararbal.dyndns.org:8045" target='_blank' rel='noreferrer' class="menu__link submenu_btn">
                                Operaciones
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item">
                    <a class="nav-link disabled" href="/construc">Corporativo</a>
                </li>             
                <li class="nav-item">
                    
                    <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Somos ARBAL</a>
                </li>
            </ul>
            </div>
        </div>
        </nav>
    )
}

export default Navbar
